import { Image, ImageProps } from '@chakra-ui/react'
import RallyLogo from 'assets/images/rally-logo.svg'
import RallyLogoDark from 'assets/images/dark-mode-logo.png'

interface AuthLogoProps extends Omit<ImageProps, 'src' | 'alt'> {
  alt?: string
  /**
   * `dark` is the wordmark for the dark auth surface and the default, since every
   * page inside AuthLayout is dark. `light` exists only for SignUpPage, the one
   * consumer still on the legacy white card.
   */
  tone?: 'dark' | 'light'
}

const AuthLogo = ({ h = '40px', alt = 'Rally', tone = 'dark', ...rest }: AuthLogoProps) => (
  <Image
    src={tone === 'dark' ? RallyLogoDark : RallyLogo}
    alt={alt}
    h={h}
    objectFit="contain"
    {...rest}
  />
)

export default AuthLogo
